(function () {
  "use strict";

// [module] src/runtime/modules/legacy/scripts-product/runtime.mjs
function registerLegacyScriptsProductRuntime() {
  /**
   * Product route behaviors extracted from scripts.js.
   * Loaded conditionally from layout/theme.liquid on product templates.
   */
  
  function normalizeTypeProductLabel(value) {
      return String(value || "").trim().replace(/\s+/g, " ").toLowerCase();
  }

  function getVariantTitleFromOption(optionNode) {
      if (!(optionNode instanceof window.HTMLOptionElement)) {
          return "";
      }
      return optionNode.getAttribute("data-variant-title") || optionNode.textContent || "";
  }

  function matchesTypeProductLabel(variantTitle, typeLabel) {
      const normalizedVariantTitle = normalizeTypeProductLabel(variantTitle);
      const normalizedTypeLabel = normalizeTypeProductLabel(typeLabel);
      if (!normalizedVariantTitle || !normalizedTypeLabel) {
          return false;
      }

      return normalizedVariantTitle === normalizedTypeLabel
          || normalizedVariantTitle.indexOf(normalizedTypeLabel + " ") === 0
          || normalizedVariantTitle.indexOf(normalizedTypeLabel + "/") === 0
          || normalizedVariantTitle.indexOf(normalizedTypeLabel + "-") === 0
          || normalizedVariantTitle.indexOf(normalizedTypeLabel + "(") === 0;
  }

  function getProductFormScope(rootNode) {
      if (rootNode instanceof window.HTMLFormElement) {
          return rootNode;
      }

      if (rootNode && rootNode.closest) {
          const nearestForm = rootNode.closest('form[name="add_to_cart"]');
          if (nearestForm) {
              return nearestForm;
          }
      }

      return rootNode && rootNode.querySelector ? rootNode : document;
  }

  function getVariantSelectFromScope(rootNode) {
      const scope = getProductFormScope(rootNode);
      if (scope instanceof window.HTMLFormElement) {
          return scope.querySelector('select[name="id"]');
      }
      return scope.querySelector ? scope.querySelector('form[name="add_to_cart"] select[name="id"], select[name="id"]') : null;
  }

  function setActiveTypeProductValue(rootNode, targetLabel, fallbackNode) {
      const scope = getProductFormScope(rootNode);
      const typeValueNodes = scope.querySelectorAll ? Array.from(scope.querySelectorAll(".type-product__value")) : [];
      if (!typeValueNodes.length) {
          return null;
      }

      const currentActiveNode = typeValueNodes.find((node) => node.classList.contains("active-value-product")) || null;
      const matchedNode = typeValueNodes.find((node) => matchesTypeProductLabel(targetLabel, node.textContent))
          || fallbackNode
          || currentActiveNode
          || typeValueNodes[0];

      typeValueNodes.forEach((node) => {
          node.classList.toggle("active-value-product", node === matchedNode);
      });

      return matchedNode;
  }

  function syncTypeProductValueFromSelect(rootNode, shouldNotifyAvailability) {
      const variantSelect = getVariantSelectFromScope(rootNode);
      if (!(variantSelect instanceof window.HTMLSelectElement)) {
          return false;
      }

      const selectedOption = variantSelect.options[variantSelect.selectedIndex];
      const selectedVariantTitle = getVariantTitleFromOption(selectedOption);
      if (!selectedVariantTitle) {
          return false;
      }

      setActiveTypeProductValue(variantSelect, selectedVariantTitle);
      if (shouldNotifyAvailability) {
          document.dispatchEvent(new CustomEvent("stern:type-product-value:changed"));
      }
      return true;
  }

  function syncTypeProductSelection(clickedValueNode) {
      if (!clickedValueNode) {
          return;
      }

      const variantSelect = getVariantSelectFromScope(clickedValueNode);
      const targetLabel = clickedValueNode.textContent || "";
      if (!(variantSelect instanceof window.HTMLSelectElement)) {
          setActiveTypeProductValue(clickedValueNode, targetLabel, clickedValueNode);
          document.dispatchEvent(new CustomEvent("stern:type-product-value:changed"));
          return;
      }

      const matchedOption = Array.from(variantSelect.options).find((optionNode) => {
          return matchesTypeProductLabel(getVariantTitleFromOption(optionNode), targetLabel);
      });
      if (!matchedOption) {
          return;
      }

      setActiveTypeProductValue(clickedValueNode, targetLabel, clickedValueNode);
      if (variantSelect.value !== matchedOption.value) {
          variantSelect.value = matchedOption.value;
          variantSelect.dispatchEvent(new window.Event("change", { bubbles: true }));
          return;
      }

      document.dispatchEvent(new CustomEvent("stern:type-product-value:changed"));
  }
  
  function initDefaultProductTypeValue(rootNode) {
      if (!window.location.toString().includes("/products")) {
          return;
      }
  
      const scope = rootNode && rootNode.querySelectorAll ? rootNode : document;
      const scopedTypeValues = scope.querySelectorAll(".type-product__value");
      if (!scopedTypeValues.length) {
          return;
      }

      if (syncTypeProductValueFromSelect(scope, false)) {
          return;
      }

      setActiveTypeProductValue(scope, "", scopedTypeValues[0]);
  }
  
  function getProductRuntimeNeeds(rootNode) {
      const scope = rootNode && rootNode.querySelector ? rootNode : document;
      return {
          hasTypeSelector: !!scope.querySelector(".type-product__value"),
          hasAvailabilityLink: !!scope.querySelector("#availability_link"),
          hasBundleUI: !!scope.querySelector("#product-with-addons"),
          hasAffirmNode: !!scope.querySelector(".affirm-as-low-as"),
          hasImageGallery: !!scope.querySelector("[data-featured-image], [data-product-thumbnail]"),
          hasYoutubeEmbeds: !!scope.querySelector('[itemprop="description"] iframe[data-youtube-src], [itemprop="description"] iframe[src*="youtube.com/embed"], [itemprop="description"] iframe[src*="youtube-nocookie.com/embed"], [itemprop="description"] .video-placeholder-youtube, [itemprop="description"] .yt-wrap'),
          hasQuantityInput: !!scope.querySelector('form[name="add_to_cart"] input[name="quantity"]')
      };
  }
  
  function normalizeImagePath(url) {
      if (!url) {
          return "";
      }
      try {
          return new URL(url, window.location.origin).pathname;
      } catch (error) {
          return String(url).split("?")[0];
      }
  }

  function withImageFormat(url, format) {
      if (!url || !format) {
          return url || "";
      }
      try {
          const parsed = new URL(url, window.location.origin);
          parsed.searchParams.set("format", format);
          return parsed.toString();
      } catch (error) {
          const normalized = String(url);
          if (/[?&]format=/.test(normalized)) {
              return normalized.replace(/([?&])format=[^&]*/i, "$1format=" + format);
          }
          return normalized + (normalized.includes("?") ? "&" : "?") + "format=" + format;
      }
  }

  function withImageFormatSrcset(srcset, format) {
      if (!srcset || !format) {
          return "";
      }
      return String(srcset)
          .split(",")
          .map((candidate) => candidate.trim())
          .filter(Boolean)
          .map((candidate) => {
              const parts = candidate.split(/\s+/);
              if (!parts.length) {
                  return "";
              }
              const descriptor = parts.length > 1 ? parts.pop() : "";
              const url = parts.join(" ");
              const formattedUrl = withImageFormat(url, format);
              return descriptor ? `${formattedUrl} ${descriptor}` : formattedUrl;
          })
          .filter(Boolean)
          .join(", ");
  }
  
  function setActiveProductThumbnail(rootNode, activeThumbNode) {
      const scope = rootNode && rootNode.querySelectorAll ? rootNode : document;
      const thumbnailNodes = scope.querySelectorAll("[data-product-thumbnail]");
      thumbnailNodes.forEach((thumbNode) => {
          const circleNode = thumbNode.querySelector(".circle-product-slide");
          if (!circleNode) {
              return;
          }
          const isActive = !!activeThumbNode && thumbNode === activeThumbNode;
          circleNode.style.background = isActive ? "#D0021B" : "#D9D9D9";
      });
  }
  
  function syncProductThumbnailStateToFeatured(rootNode) {
      const scope = rootNode && rootNode.querySelector ? rootNode : document;
      const featuredImageNode = scope.querySelector("[data-featured-image]") || document.querySelector("[data-featured-image]");
      if (!featuredImageNode) {
          return;
      }
  
      const featuredImageId = featuredImageNode.getAttribute("data-image-id") || "";
      const featuredImageSrc = featuredImageNode.currentSrc || featuredImageNode.getAttribute("src") || "";
      const normalizedFeaturedImagePath = normalizeImagePath(featuredImageSrc);
  
      const thumbnailNodes = Array.from(scope.querySelectorAll("[data-product-thumbnail]"));
      if (!thumbnailNodes.length) {
          return;
      }
  
      let activeThumbNode = null;
      if (featuredImageId) {
          activeThumbNode = thumbnailNodes.find((thumbNode) => (
              thumbNode.getAttribute("data-image-id") === featuredImageId
          )) || null;
      }
  
      if (!activeThumbNode && normalizedFeaturedImagePath) {
          activeThumbNode = thumbnailNodes.find((thumbNode) => {
              const thumbSrc = thumbNode.getAttribute("data-image-src") || "";
              return normalizeImagePath(thumbSrc) === normalizedFeaturedImagePath;
          }) || null;
      }
  
      setActiveProductThumbnail(scope, activeThumbNode);
  }
  
  function updateFeaturedImageFromThumbnail(thumbNode, rootNode) {
      const scope = rootNode && rootNode.querySelector ? rootNode : document;
      const featuredImageNode = scope.querySelector("[data-featured-image]") || document.querySelector("[data-featured-image]");
      if (!featuredImageNode || !thumbNode) {
          return;
      }
  
      const nextSrc = thumbNode.getAttribute("data-image-src") || "";
      const nextSrcset = thumbNode.getAttribute("data-image-srcset") || "";
      const nextImageId = thumbNode.getAttribute("data-image-id") || "";
  
      if (nextSrc) {
          featuredImageNode.setAttribute("src", nextSrc);
      }
      if (nextSrcset) {
          featuredImageNode.setAttribute("srcset", nextSrcset);
      }
      if (nextImageId) {
          featuredImageNode.setAttribute("data-image-id", nextImageId);
      }

      const pictureNode = featuredImageNode.closest("picture");
      if (pictureNode) {
          const avifSourceNode = pictureNode.querySelector('source[type="image/avif"]');
          const webpSourceNode = pictureNode.querySelector('source[type="image/webp"]');
          const nextAvifSrcset = thumbNode.getAttribute("data-image-srcset-avif") || withImageFormatSrcset(nextSrcset, "avif");
          const nextWebpSrcset = thumbNode.getAttribute("data-image-srcset-webp") || withImageFormatSrcset(nextSrcset, "webp");

          if (avifSourceNode && nextAvifSrcset) {
              avifSourceNode.setAttribute("srcset", nextAvifSrcset);
          }
          if (webpSourceNode && nextWebpSrcset) {
              webpSourceNode.setAttribute("srcset", nextWebpSrcset);
          }
      }
  
      setActiveProductThumbnail(scope, thumbNode);
  }
  
  function initProductImageGallery(rootNode) {
      syncProductThumbnailStateToFeatured(rootNode);
      warmProductGalleryImages(rootNode);
  }
  
  function bindProductImageGalleryListenersOnce() {
      if (window.__sternProductImageGalleryBound === true) {
          return;
      }
      window.__sternProductImageGalleryBound = true;
  
      document.addEventListener("click", (event) => {
          const thumbNode = event.target && event.target.closest
              ? event.target.closest("[data-product-thumbnail]")
              : null;
          if (!thumbNode) {
              return;
          }
          event.preventDefault();
          updateFeaturedImageFromThumbnail(thumbNode, document);
      });
  
      document.addEventListener("theme:variant:change", () => {
          window.setTimeout(() => {
              syncProductThumbnailStateToFeatured(document);
          }, 0);
      });
  }

  const warmedGalleryAssetKeys = new Set();
  let productYoutubeStylesReady = false;

  function warmProductGalleryImages(rootNode) {
      const scope = rootNode && rootNode.querySelector ? rootNode : document;
      const thumbnailNodes = Array.from(scope.querySelectorAll("[data-product-thumbnail]"));
      if (!thumbnailNodes.length) {
          return;
      }

      const preload = () => {
          thumbnailNodes.forEach((thumbNode) => {
              const src = thumbNode.getAttribute("data-image-src") || "";
              const srcset = thumbNode.getAttribute("data-image-srcset") || "";
              const key = src + "::" + srcset;
              if (!src || warmedGalleryAssetKeys.has(key)) {
                  return;
              }

              warmedGalleryAssetKeys.add(key);
              const image = new window.Image();
              if (srcset) {
                  image.srcset = srcset;
                  image.sizes = "1070px";
              }
              image.decoding = "async";
              image.src = src;
          });
      };

      if (typeof window.requestIdleCallback === "function") {
          window.requestIdleCallback(preload, { timeout: 500 });
          return;
      }

      window.setTimeout(preload, 0);
  }

  function ensureProductYoutubeStyles() {
      if (productYoutubeStylesReady || document.getElementById("stern-product-youtube-styles")) {
          productYoutubeStylesReady = true;
          return;
      }

      const styleNode = document.createElement("style");
      styleNode.id = "stern-product-youtube-styles";
      styleNode.textContent = [
          ".yt-wrap{position:relative;max-width:100%;background:#000;overflow:hidden}",
          ".yt-inner{position:relative;width:100%;height:0;padding-top:56.25%}",
          ".yt-inner iframe{position:absolute;inset:0;width:100%;height:100%;border:0;display:block}",
          ".yt-wrap:not([data-loaded=\"1\"]) .yt-inner iframe{pointer-events:none}",
          ".yt-play{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);z-index:2;border:0;border-radius:14px;padding:0;cursor:pointer;background:transparent;width:68px;height:48px;display:flex;align-items:center;justify-content:center;transition:opacity .2s}",
          ".yt-play:hover svg path:first-child,.yt-play:focus svg path:first-child{fill:#f00}",
          ".yt-play svg{pointer-events:none}",
          ".yt-play.yt-loading{opacity:.5;cursor:wait}",
          ".yt-wrap[data-loaded=\"1\"] .yt-play{display:none}"
      ].join("");
      document.head.appendChild(styleNode);
      productYoutubeStylesReady = true;
  }

  function extractYoutubeIdFromUrl(url) {
      const normalized = String(url || "");
      const match = normalized.match(/(?:youtube(?:-nocookie)?\.com\/embed\/|img\.youtube\.com\/vi\/)([A-Za-z0-9_-]+)/i);
      return match ? match[1] : "";
  }

  function normalizeYoutubeEmbedUrl(url, videoId) {
      const rawUrl = String(url || "").trim();
      let embedUrl = rawUrl;
      if (!embedUrl && videoId) {
          embedUrl = `https://www.youtube.com/embed/${videoId}`;
      }
      if (!embedUrl) {
          return "";
      }

      try {
          const parsedUrl = new URL(embedUrl, window.location.origin);
          if (!/youtube(?:-nocookie)?\.com$/i.test(parsedUrl.hostname)) {
              return "";
          }
          parsedUrl.hostname = "www.youtube-nocookie.com";
          parsedUrl.searchParams.delete("si");
          return parsedUrl.toString();
      } catch (error) {
          return embedUrl
              .replace(/\/\/(?:www\.)?youtube\.com\//i, "//www.youtube-nocookie.com/")
              .replace(/[?&]si=[A-Za-z0-9_-]+/g, "")
              .replace("?&", "?")
              .replace(/\?$/, "");
      }
  }

  function createYoutubePlayButton() {
      const button = document.createElement("button");
      button.type = "button";
      button.className = "yt-play";
      button.setAttribute("aria-label", "Play video");
      button.innerHTML = '<svg viewBox="0 0 68 48" width="68" height="48" aria-hidden="true" focusable="false"><path d="M66.52 7.74c-.78-2.93-2.49-5.41-5.42-6.19C55.79.13 34 0 34 0S12.21.13 6.9 1.55c-2.93.78-4.64 3.26-5.42 6.19C.06 13.05 0 24 0 24s.06 10.95 1.48 16.26c.78 2.93 2.49 5.41 5.42 6.19C12.21 47.87 34 48 34 48s21.79-.13 27.1-1.55c2.93-.78 4.64-3.26 5.42-6.19C67.94 34.95 68 24 68 24s-.06-10.95-1.48-16.26z" fill="rgba(0,0,0,.65)"></path><path d="M45 24L27 14v20" fill="#fff"></path></svg>';
      return button;
  }

  function createYoutubeWrap(videoId, iframeAttributes) {
      const wrap = document.createElement("div");
      wrap.className = "yt-wrap";
      wrap.setAttribute("data-ytid", videoId);

      const inner = document.createElement("div");
      inner.className = "yt-inner";

      inner.appendChild(createYoutubePlayButton());

      const iframe = document.createElement("iframe");
      iframe.className = "yt-iframe";
      iframe.setAttribute("data-src", normalizeYoutubeEmbedUrl(iframeAttributes.src, videoId));
      iframe.setAttribute("src", "about:blank");
      iframe.setAttribute("title", iframeAttributes.title || "YouTube video player");
      iframe.setAttribute("allow", iframeAttributes.allow || "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share");
      iframe.setAttribute("allowfullscreen", "true");
      iframe.setAttribute("loading", "lazy");
      iframe.setAttribute("referrerpolicy", iframeAttributes.referrerpolicy || "strict-origin-when-cross-origin");
      inner.appendChild(iframe);

      wrap.appendChild(inner);
      return wrap;
  }

  function extractYoutubePlaceholderThumb(placeholderNode) {
      if (!(placeholderNode instanceof window.HTMLElement)) {
          return "";
      }
      const style = placeholderNode.getAttribute("style") || "";
      const match = style.match(/https?:\/\/img\.youtube\.com\/vi\/([A-Za-z0-9_-]+)\/[^)"']+/i);
      return match ? match[0] : "";
  }

  function liftWrapOutOfParagraph(wrap) {
      var parentP = wrap.parentElement;
      if (!parentP || parentP.tagName !== "P") {
          return;
      }
      parentP.after(wrap);
      if (!parentP.textContent.trim() && !parentP.children.length) {
          parentP.remove();
      }
  }

  function replaceYoutubeNode(node) {
      if (!node || node.closest(".yt-wrap")) {
          return null;
      }

      if (node.matches && node.matches('iframe[data-youtube-src], iframe[src*="youtube.com/embed"], iframe[src*="youtube-nocookie.com/embed"]')) {
          const src = node.getAttribute("data-youtube-src") || node.getAttribute("src") || "";
          const videoId = extractYoutubeIdFromUrl(src);
          if (!videoId) {
              return null;
          }
          const wrap = createYoutubeWrap(videoId, {
              src,
              title: node.getAttribute("title") || "",
              allow: node.getAttribute("allow") || "",
              referrerpolicy: node.getAttribute("referrerpolicy") || ""
          });
          node.replaceWith(wrap);
          liftWrapOutOfParagraph(wrap);
          return wrap;
      }

      if (node.matches && node.matches(".video-placeholder-youtube")) {
          const thumbnailUrl = extractYoutubePlaceholderThumb(node);
          const videoId = extractYoutubeIdFromUrl(thumbnailUrl);
          if (!videoId) {
              return null;
          }
          const wrap = createYoutubeWrap(videoId, {
              src: `https://www.youtube.com/embed/${videoId}`,
              title: "YouTube video player",
              allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
              referrerpolicy: "strict-origin-when-cross-origin"
          });
          node.replaceWith(wrap);
          liftWrapOutOfParagraph(wrap);
          return wrap;
      }

      return null;
  }

  function upgradeYoutubeWrap(wrapNode, autoplay) {
      if (!(wrapNode instanceof window.HTMLElement) || wrapNode.getAttribute("data-loaded") === "1") {
          return;
      }

      const iframe = wrapNode.querySelector("iframe");
      if (!(iframe instanceof window.HTMLIFrameElement)) {
          return;
      }

      let nextSrc = iframe.getAttribute("data-src") || "";
      if (!nextSrc) {
          return;
      }

      try {
          const parsed = new URL(nextSrc, window.location.origin);
          parsed.searchParams.set("controls", "1"); // force player controls/progress bar (overrides controls=0 from the source embed)
          if (autoplay) {
              parsed.searchParams.set("autoplay", "1");
          }
          nextSrc = parsed.toString();
      } catch (error) {
          nextSrc = nextSrc.replace(/([?&])controls=\d/i, "$1controls=1");
          if (nextSrc.indexOf("controls=") === -1) {
              nextSrc += nextSrc.indexOf("?") === -1 ? "?controls=1" : "&controls=1";
          }
          if (autoplay) {
              nextSrc += "&autoplay=1";
          }
      }

      iframe.setAttribute("src", nextSrc);
      wrapNode.setAttribute("data-loaded", "1");
  }

  function resetYoutubeWrap(wrapNode) {
      if (!(wrapNode instanceof window.HTMLElement)) {
          return;
      }

      const iframe = wrapNode.querySelector("iframe.yt-iframe");
      if (iframe instanceof window.HTMLIFrameElement) {
          iframe.setAttribute("src", "about:blank");
      }

      const playButton = wrapNode.querySelector(".yt-play");
      if (playButton) {
          playButton.classList.remove("yt-loading");
      }

      wrapNode.removeAttribute("data-loaded");
  }

  function resetProductYoutubeEmbeds(rootNode) {
      const scope = rootNode && rootNode.querySelectorAll ? rootNode : document;
      scope.querySelectorAll('.yt-wrap[data-loaded="1"]').forEach((wrapNode) => {
          resetYoutubeWrap(wrapNode);
      });
  }

  function cookieYesUpdateHasRejections(event) {
      const detail = event && event.detail;
      return !!(detail && Array.isArray(detail.rejected) && detail.rejected.length);
  }

  function initProductYoutubeEmbeds(rootNode) {
      const scope = rootNode && rootNode.querySelector ? rootNode : document;
      const descriptionNode = scope.querySelector('[itemprop="description"]');
      if (!descriptionNode) {
          return;
      }

      ensureProductYoutubeStyles();
      const candidates = Array.from(descriptionNode.querySelectorAll('iframe[data-youtube-src], iframe[src*="youtube.com/embed"], iframe[src*="youtube-nocookie.com/embed"], .video-placeholder-youtube'));
      candidates.forEach((node) => {
          replaceYoutubeNode(node);
      });
  }

  function normalizeSoldOutProductCtas(rootNode) {
      const scope = rootNode && rootNode.querySelector ? rootNode : document;
      const soldOutCtas = Array.from(scope.querySelectorAll('#product-add a.addtocart[href="#"]'));
      if (!soldOutCtas.length) {
          return;
      }

      soldOutCtas.forEach((anchorNode) => {
          if (!(anchorNode instanceof window.HTMLAnchorElement)) {
              return;
          }

          const buttonNode = document.createElement("button");
          buttonNode.type = "button";
          buttonNode.className = anchorNode.className;
          buttonNode.disabled = true;
          buttonNode.setAttribute("aria-disabled", "true");
          buttonNode.style.pointerEvents = "none";
          buttonNode.style.opacity = ".65";
          buttonNode.style.cursor = "not-allowed";
          buttonNode.textContent = (anchorNode.textContent || "").trim();

          anchorNode.replaceWith(buttonNode);
      });
  }

  function bindProductYoutubeListenersOnce() {
      if (window.__sternProductYoutubeBound === true) {
          return;
      }
      window.__sternProductYoutubeBound = true;

      document.addEventListener("click", (event) => {
          const wrapNode = event.target && event.target.closest ? event.target.closest(".yt-wrap") : null;
          if (!wrapNode) {
              return;
          }

          event.preventDefault();
          upgradeYoutubeWrap(wrapNode, true);
      }, true);

      const resetRevokedYoutubeEmbeds = (event) => {
          if (cookieYesUpdateHasRejections(event)) {
              resetProductYoutubeEmbeds(document);
          }
      };
      document.addEventListener("cookieyes_consent_update", resetRevokedYoutubeEmbeds);
      document.addEventListener("cookieyes-consent-updated", resetRevokedYoutubeEmbeds);
  }
  
  function getQuantityInputFromNode(node) {
      const formNode = node && node.closest ? node.closest('form[name="add_to_cart"]') : null;
      if (!formNode) {
          return null;
      }
      return formNode.querySelector('input[name="quantity"]');
  }
  
  function clampQuantityInputValue(quantityInput) {
      if (!quantityInput) {
          return;
      }
  
      const minValue = Number(quantityInput.getAttribute("min") || "1");
      let parsedValue = Number(quantityInput.value);
      if (!Number.isFinite(parsedValue)) {
          parsedValue = minValue;
      }
      if (parsedValue < minValue) {
          parsedValue = minValue;
      }
      quantityInput.value = String(parsedValue);
  }
  
  function normalizeProductQuantityInputs(rootNode) {
      const scope = rootNode && rootNode.querySelectorAll ? rootNode : document;
      scope.querySelectorAll('form[name="add_to_cart"] input[name="quantity"]').forEach((quantityInput) => {
          clampQuantityInputValue(quantityInput);
      });
  }
  
  function bindProductQuantityControlsOnce() {
      if (window.__sternProductQuantityControlsBound === true) {
          return;
      }
      window.__sternProductQuantityControlsBound = true;
  
      document.addEventListener("click", (event) => {
          const qtyButton = event.target && event.target.closest
              ? event.target.closest("[data-qty-change]")
              : null;
          if (!qtyButton) {
              return;
          }
  
          event.preventDefault();
          const quantityInput = getQuantityInputFromNode(qtyButton);
          if (!quantityInput) {
              return;
          }
  
          const step = Number(qtyButton.getAttribute("data-qty-change") || "0");
          if (!Number.isFinite(step) || step === 0) {
              return;
          }
  
          const minValue = Number(quantityInput.getAttribute("min") || "1");
          const currentValue = Number(quantityInput.value);
          const safeCurrentValue = Number.isFinite(currentValue) ? currentValue : minValue;
          const nextValue = Math.max(minValue, safeCurrentValue + step);
          quantityInput.value = String(nextValue);
      });
  
      document.addEventListener("change", (event) => {
          const quantityInput = event.target && event.target.matches
              ? (event.target.matches('form[name="add_to_cart"] input[name="quantity"]') ? event.target : null)
              : null;
          if (!quantityInput) {
              return;
          }
          clampQuantityInputValue(quantityInput);
      });
  }

  let cartNotificationTimerId = null;
  let cartNotificationHideTimerId = null;

  function showCartAddedBanner(productTitle) {
      const notificationNode = document.getElementById("global-cart-notification");
      const titleNode = document.getElementById("global-cart-notification-title");
      if (!notificationNode || !titleNode) {
          return false;
      }

      titleNode.textContent = String(productTitle || "").trim() || "Product";
      notificationNode.classList.remove("hidden", "show");
      notificationNode.setAttribute("aria-hidden", "false");

      if (cartNotificationTimerId) {
          window.clearTimeout(cartNotificationTimerId);
      }
      if (cartNotificationHideTimerId) {
          window.clearTimeout(cartNotificationHideTimerId);
      }

      requestAnimationFrame(() => {
          notificationNode.classList.add("show");
      });

      cartNotificationTimerId = window.setTimeout(() => {
          notificationNode.classList.remove("show");
          cartNotificationHideTimerId = window.setTimeout(() => {
              notificationNode.classList.add("hidden");
              notificationNode.setAttribute("aria-hidden", "true");
          }, 500);
      }, 3000);

      return true;
  }
  
  function bindProductCartFeedbackOnce() {
      if (window.__sternProductCartFeedbackBound === true) {
          return;
      }
      window.__sternProductCartFeedbackBound = true;
  
      window.addEventListener("theme:cart:added", (event) => {
          const detail = event && event.detail ? event.detail : {};
          const formNode = detail.form;
          if (!(formNode instanceof window.HTMLFormElement) || formNode.getAttribute("name") !== "add_to_cart") {
              return;
          }
  
          const payload = detail.response || {};
          const itemTitle = payload.product_title || payload.title || "";
          const productTitleNode = document.querySelector("h1[itemprop='name'], .template-product h1, .t_h2.t_f\\:fjalla");
          const fallbackTitle = productTitleNode ? (productTitleNode.textContent || "").trim() : "Product";
          const safeTitle = itemTitle || fallbackTitle;

          if (showCartAddedBanner(safeTitle)) {
              return;
          }

          if (window.alertNotification && typeof window.alertNotification.success === "function") {
              window.alertNotification.success(safeTitle + " has been added to your cart.");
          }
      });
  }
  
  document.addEventListener("click", (event) => {
      const clickedValueNode = event.target && event.target.closest
          ? event.target.closest(".type-product__value")
          : null;
      if (!clickedValueNode) {
          return;
      }
  
      syncTypeProductSelection(clickedValueNode);
  });

  document.addEventListener("change", (event) => {
      const target = event.target;
      if (!(target instanceof window.HTMLSelectElement) || target.name !== "id") {
          return;
      }

      if (!target.closest('form[name="add_to_cart"]')) {
          return;
      }

      syncTypeProductValueFromSelect(target, true);
  });
  
  if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => {
          initDefaultProductTypeValue(document);
      });
  } else {
      initDefaultProductTypeValue(document);
  }
  
  document.addEventListener("shopify:section:load", (event) => {
      const rootNode = event && event.target ? event.target : document;
      const runtimeNeeds = getProductRuntimeNeeds(rootNode);
      if (runtimeNeeds.hasTypeSelector) {
          initDefaultProductTypeValue(rootNode);
      }
      if (runtimeNeeds.hasImageGallery) {
          bindProductImageGalleryListenersOnce();
          initProductImageGallery(rootNode);
      }
      if (runtimeNeeds.hasQuantityInput) {
          bindProductQuantityControlsOnce();
          normalizeProductQuantityInputs(rootNode);
          bindProductCartFeedbackOnce();
      }
      if (runtimeNeeds.hasYoutubeEmbeds) {
          bindProductYoutubeListenersOnce();
          initProductYoutubeEmbeds(rootNode);
      }
      normalizeSoldOutProductCtas(rootNode);
      if (runtimeNeeds.hasAvailabilityLink) {
          loadProductAvailabilityScriptIfNeeded(rootNode, true);
      }
      if (runtimeNeeds.hasBundleUI) {
          loadProductBundleScriptIfNeeded(rootNode, true);
      }
      if (runtimeNeeds.hasAffirmNode) {
          scheduleProductAffirmSpacingPatch(rootNode);
      }
  });
  
  document.addEventListener("shopify:section:unload", (event) => {
      const rootNode = event && event.target ? event.target : document;
      if (window.__sternProductBundle && typeof window.__sternProductBundle.onSectionUnload === "function") {
          window.__sternProductBundle.onSectionUnload(rootNode);
      }
  });

  window.addEventListener("theme:product:section:rendered", () => {
      window.setTimeout(() => {
          initDefaultProductTypeValue(document);
          document.dispatchEvent(new CustomEvent("stern:type-product-value:changed"));
      }, 0);
  });
  
  function loadScriptOnce(config) {
      if (window.__sternLoadScriptOnce && typeof window.__sternLoadScriptOnce === "function") {
          return window.__sternLoadScriptOnce(config);
      }
      return Promise.resolve(false);
  }
  
  function getProductAvailabilityScriptUrl() {
      if (
          window.__sternTheme &&
          typeof window.__sternTheme.productAvailabilityUrl === "string" &&
          window.__sternTheme.productAvailabilityUrl.length
      ) {
          return window.__sternTheme.productAvailabilityUrl;
      }
      return "/assets/scripts-product-availability.js";
  }
  
  function rootNeedsProductAvailability(rootNode) {
      const scope = rootNode && rootNode.querySelector ? rootNode : document;
      return !!scope.querySelector("#availability_link");
  }
  
  function loadProductAvailabilityScriptIfNeeded(rootNode, precheckedNeedsAvailability) {
      const needsAvailability = precheckedNeedsAvailability === true || rootNeedsProductAvailability(rootNode);
      if (!needsAvailability) {
          return Promise.resolve(false);
      }
  
      if (window.__sternProductAvailability && typeof window.__sternProductAvailability.onSectionLoad === "function") {
          window.__sternProductAvailability.onSectionLoad(rootNode);
          return Promise.resolve(true);
      }
  
      const productAvailabilityScriptUrl = getProductAvailabilityScriptUrl();
      if (!productAvailabilityScriptUrl) {
          return Promise.resolve(false);
      }
  
      return loadScriptOnce({
          key: "stern-product-availability",
          url: productAvailabilityScriptUrl,
          scriptAttr: "data-stern-product-availability"
      }).then((loaded) => {
          if (loaded && window.__sternProductAvailability && typeof window.__sternProductAvailability.onSectionLoad === "function") {
              window.__sternProductAvailability.onSectionLoad(rootNode);
          }
          return loaded;
      });
  }
  
  function getProductBundleScriptUrl() {
      if (
          window.__sternTheme &&
          typeof window.__sternTheme.productBundleUrl === "string" &&
          window.__sternTheme.productBundleUrl.length
      ) {
          return window.__sternTheme.productBundleUrl;
      }
      return "/assets/scripts-product-bundle.js";
  }
  
  function rootNeedsProductBundle(rootNode) {
      const scope = rootNode && rootNode.querySelector ? rootNode : document;
      return !!scope.querySelector("#product-with-addons");
  }
  
  function loadProductBundleScriptIfNeeded(rootNode, precheckedNeedsBundle) {
      const needsBundle = precheckedNeedsBundle === true || rootNeedsProductBundle(rootNode);
      if (!needsBundle) {
          return Promise.resolve(false);
      }
  
      if (window.__sternProductBundle && typeof window.__sternProductBundle.onSectionLoad === "function") {
          window.__sternProductBundle.onSectionLoad(rootNode);
          return Promise.resolve(true);
      }
  
      const productBundleScriptUrl = getProductBundleScriptUrl();
      if (!productBundleScriptUrl) {
          return Promise.resolve(false);
      }
  
      return loadScriptOnce({
          key: "stern-product-bundle",
          url: productBundleScriptUrl,
          scriptAttr: "data-stern-product-bundle"
      }).then((loaded) => {
          if (loaded && window.__sternProductBundle && typeof window.__sternProductBundle.onSectionLoad === "function") {
              window.__sternProductBundle.onSectionLoad(rootNode);
          }
          return loaded;
      });
  }
  
  function scheduleProductAffirmSpacingPatch(rootNode) {
      if (window.__sternScheduleAffirmSpacingPatch && typeof window.__sternScheduleAffirmSpacingPatch === "function") {
          window.__sternScheduleAffirmSpacingPatch({
              rootNode: rootNode,
              timerKey: "product"
          });
      }
  }
  
  if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => {
          const runtimeNeeds = getProductRuntimeNeeds(document);
          if (runtimeNeeds.hasImageGallery) {
              bindProductImageGalleryListenersOnce();
              initProductImageGallery(document);
          }
          if (runtimeNeeds.hasQuantityInput) {
              bindProductQuantityControlsOnce();
              normalizeProductQuantityInputs(document);
              bindProductCartFeedbackOnce();
          }
          if (runtimeNeeds.hasYoutubeEmbeds) {
              bindProductYoutubeListenersOnce();
              initProductYoutubeEmbeds(document);
          }
          normalizeSoldOutProductCtas(document);
          if (runtimeNeeds.hasAvailabilityLink) {
              loadProductAvailabilityScriptIfNeeded(document, true);
          }
          if (runtimeNeeds.hasBundleUI) {
              loadProductBundleScriptIfNeeded(document, true);
          }
          if (runtimeNeeds.hasAffirmNode) {
              scheduleProductAffirmSpacingPatch(document);
          }
      });
  } else {
      const runtimeNeeds = getProductRuntimeNeeds(document);
      if (runtimeNeeds.hasImageGallery) {
          bindProductImageGalleryListenersOnce();
          initProductImageGallery(document);
      }
      if (runtimeNeeds.hasQuantityInput) {
          bindProductQuantityControlsOnce();
          normalizeProductQuantityInputs(document);
          bindProductCartFeedbackOnce();
      }
      if (runtimeNeeds.hasYoutubeEmbeds) {
          bindProductYoutubeListenersOnce();
          initProductYoutubeEmbeds(document);
      }
      normalizeSoldOutProductCtas(document);
      if (runtimeNeeds.hasAvailabilityLink) {
          loadProductAvailabilityScriptIfNeeded(document, true);
      }
      if (runtimeNeeds.hasBundleUI) {
          loadProductBundleScriptIfNeeded(document, true);
      }
      if (runtimeNeeds.hasAffirmNode) {
          scheduleProductAffirmSpacingPatch(document);
      }
  }
}

// [module] src/runtime/entries/scripts-product.mjs

registerLegacyScriptsProductRuntime();

})();
